import {Component} from "@angular/core";

@Component({
  selector: "core-simple",
  template: `
  <usecase-container title="Simple" src="core/simple">
    <usecase-content>
      <p>Hello Angular 2</p>
    </usecase-content>
  </usecase-container>
  `
})
export class SimpleComponent {
}



/** WEBPACK FOOTER **
 ** ./script/core/simple/component.ts
 **/